import React, { useContext, useState } from "react";
import "./setting.css";

import { IoIosUnlock } from "react-icons/io";
import { PiCrownSimpleFill } from "react-icons/pi";
import { FaAt } from "react-icons/fa";
import { BsPersonFillX } from "react-icons/bs";

import { AuthContext } from "../../context/AuthContext";
const Settings = ({ setActiveSection }) => {
  const { role } = useContext(AuthContext);

  const [activeSection, setActive] = useState("");

  const handleSectionClick = (section) => {
    setActive(section);
    setActiveSection(section);
  };

  return (
    <div className="settings">
      <div className="settings-main">
        <div className="settings-sidebar">
          <div className="seachtopic">Settings</div>

          {/* Account Settings */}
          <div className="suptopic">Account Settings</div>
          <div className="settings-options">
            <div
              className={`settings-option ${
                activeSection === "password" ? "active" : ""
              }`}
              onClick={() => handleSectionClick("password")}
            >
              <div className="settingManagePasswordNavIconborder">
                <IoIosUnlock className="settingManagePasswordNavIcon"  style={{backgroundColor:"#6e0605", color:"white"}}/>
              </div>
              Manage Password
            </div>

            {(role === "actor" || role === "crew") && (
              <>
                <div className="suptopic">Billing Information</div>
                <div
                  className={`settings-option ${
                    activeSection === "billing" ? "active" : ""
                  }`}
                  onClick={() => handleSectionClick("billing")}
                >
                  <PiCrownSimpleFill className="settingSubscriptionIcon" style={{backgroundColor:"#6e0605", color:"white"}} />
                  <span>Subscription</span>
                </div>
              </>
            )}

            <div className="suptopic">Notifications</div>
            <div
              className={`settings-option ${
                activeSection === "notifications" ? "active" : ""
              }`}
              onClick={() => handleSectionClick("notifications")}
            >
              <FaAt className="settingEmailIcon" style={{backgroundColor:"#6e0605", color:"white"}}/>
              Email Notifications
            </div>

            {/* 
            <div className="suptopic">Account Settings</div> */}

            {/*  Account Settings */}
            {/* <div className="suptopic">Account Settings</div>
>>>>>>> f25781ddb519c885ce22cb0fc90d007f491c85b2
            <div
              className={`settings-option ${
                activeSection === "deactivate" ? "active" : ""
              }`}
              onClick={() => handleSectionClick("deactivate")}
            >
              <BsPersonFillX className="settingDeactivateIcon" />
              Deactivate Account
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
